import { render } from "./CustomTa6.vue?vue&type=template&id=0630b225"
import script from "./CustomTa6.vue?vue&type=script&lang=js"
export * from "./CustomTa6.vue?vue&type=script&lang=js"

import "./CustomTa6.vue?vue&type=style&index=0&id=0630b225&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__